/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".noticeArea[_ngcontent-%COMP%]{padding:20px;background-color:#fffeef;background-origin:padding-box;border:1px solid #d6d6d6;border-radius:5px}.top-33[_ngcontent-%COMP%]{margin-top:33px}.share_helpSec[_ngcontent-%COMP%]{left:69vw!important;margin-top:-1px!important}button[_ngcontent-%COMP%]:disabled{opacity:.5}"];
export { styles as styles };
